import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, Team } from "..";

export const JoinOurTeam = () => {
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const aboutDetails = useStore((state) => state.aboutDetails);

  const overlay = {
    where: "theTeam",
    title: "Join Our Team",
    caption: "Become part of the Todo's Translator family.",
  };
  const info = {
    routes: {
      Home: "/",
      "Todo's Team": getLink(pathTitles.MEETTHETEAM),
      "Join Our Team": getLink(pathTitles.JOINOURTEAM),
    },
    body: aboutDetails.JOINOURTEAM.body,
  };
  return (
    <>
      <SEO
        title="Join Our Team — Dog Training Careers"
        description="Passionate about dogs? Todo's Translator is hiring. Learn what we look for in a professional trainer and how to apply."
        path="/meet-the-trainer/join-our-team"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <Team info={info} />
          <Container className="small_container common_container">
            <Row>
              <Col>
                <Card className="common_card text-center">
                  <Card.Body>
                    <Card.Title>Ready to Apply?</Card.Title>
                    <Card.Text>
                      If you&apos;re passionate about dogs and want to join our
                      team, we&apos;d love to hear from you!
                    </Card.Text>
                    <Button
                      as={Link}
                      to={getLink(pathTitles.CONTACTUS)}
                      variant="primary"
                    >
                      Contact Us
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};
